/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcCheckAllNone
 * @restrict AE
 * @scope
 * @requires dataTable
 * @param {string} targetContainerId The html id of the tag this directive should target
 * @description
 * The wcCheckAllNone directive sets up check all/none functionality for an array of checkboxes. It can be used in conjunction
 * with a Data table. The directive will inject check all/none links and provide the necessary functions to make them function.
 */

angular.module('WebCoreModule')
	.directive('wcCheckAllNone', function() {
		return {
			restrict: 'AE',
			require: ['wcCheckAllNone', '?^datatable'],
			scope: {
				targetContainerId: '@targetContainerId'
			},
			template: '<a class="select-all" href="javascript:;" ng-click="checkAllNoneController.checkAll()">{{"actions.selectAll" | translate}}</a> | <a class="select-none" href="javascript:;" ng-click="checkAllNoneController.checkNone()">{{"actions.selectNone"| translate}}</a>',
			controllerAs: 'checkAllNoneController',
			controller: ['$scope', '$element', 'WcTranslateConfiguratorService', function($scope, $element, WcTranslateConfiguratorService) {

				WcTranslateConfiguratorService.loadPartAndRefresh('WC-checkAllNone');

				this.responsiveTableController = angular.element('#'+$scope.targetContainerId).controller('wcResponsiveTable');

				$scope.viewScope = $scope.$parent;

				$scope.toggleCheckAllExists = false;

				$scope.setToggleCheckAllExists = function(exists) {
					$scope.toggleCheckAllExists = exists;
				};

				$scope.getToggleCheckAllExists = function() {
					return $scope.toggleCheckAllExists;
				};


				/* Start Select All Functionality */

				this.checkAll = function() {
					if(this.responsiveTableController){
						this.responsiveTableController.WcTableScopeService.getTableScope().$broadcast('table.select.checkbox.all');
						this.responsiveTableController.WcTableScopeService.getTableScope().$broadcast('table.select.button.all');
                        var checkbox = $('#' + $scope.targetContainerId).find('input[type="checkbox"].wc-header-checkbox');
						checkbox.prop('checked', true);
					} else {
						var checkBoxList = $('#' + $scope.targetContainerId).find('input[type="checkbox"]:not(.toggle-check-all)');
						angular.forEach(checkBoxList, function (item) {
							// item.checked = false;
							// item.click();

							if(!item.checked) {
								item.click();
							}
							item.checked = true;
						});
					}
				};
				/* End Select All Functionality */

				/* Start Select None Functionality */

				this.checkNone = function() {
					if(this.responsiveTableController){
                        this.responsiveTableController.WcTableScopeService.getTableScope().$broadcast('table.select.checkbox.none');
                        this.responsiveTableController.WcTableScopeService.getTableScope().$broadcast('table.select.button.none');
                        var checkbox = $('#' + $scope.targetContainerId).find('input[type="checkbox"].wc-header-checkbox');
                        checkbox.prop('checked', false);
                    } else {
						var checkBoxList = $('#' + $scope.targetContainerId).find('input[type="checkbox"]:not(.toggle-check-all)');
						angular.forEach(checkBoxList, function (item) {
							// item.checked = true;
							// item.click();

							if(item.checked) {
								item.click();
							}
							item.checked = false;
						});
					}
				};
			}],
			link: function(scope, elem, attrs, controllers) {
				var datatableController = controllers[1];

				if (datatableController) {
					scope.setToggleCheckAllExists(datatableController.getToggleCheckAllExists());
				}


			}

		};
	});
